module.exports = __webpack_public_path__ + "img/code.918de15b.png";